import { RouteObject } from 'react-router-dom'
import { PageLoadingSupport } from '$components/common'
import { default as Connections } from '.'

export const connectionRoutes: RouteObject[] = [
  {
    path: '/connections',
    element: (
      <PageLoadingSupport>
        <Connections.Connections.Component />
      </PageLoadingSupport>
    ),
    loader: Connections.Connections.Loader,
  },
]
